module.exports = __webpack_public_path__ + "static/img/edge_img_6.0669b8d7.png";